// Beside a money figure while a cash ledger page failed to load, so the figure may be short.
export const LedgerIncompleteMark = () => (
  <span className="text-xs font-medium text-amber-700">
    (ledger incomplete)
  </span>
)
